module.exports = __webpack_public_path__ + "img/logo3.4fe79ae3.png";